import type { FilterCondition, FilterStage, StageCombinator } from "./state";

export type ColumnFiltersAction =
  | SetFilterAction
  | SetColumnStagesAction
  | DeleteFilterAction
  | DeleteStageAction
  | ClearFiltersAction
  | SetCombinatorAction;

export class SetFilterAction {
  readonly type = "set_filter";
  constructor(
    readonly payload: {
      columnId: string;
      /** When omitted, the stage is appended. */
      stageIndex?: number;
      value: string;
      condition: FilterCondition;
      value2?: string;
    },
  ) {}
}

/**
 * Replaces a column's entire stage list in one step, creating the filter when
 * the column has none yet and keeping an existing filter's combinator.
 *
 * The popover's pending-stage commit needs to publish several stages at once.
 * Expressing that as a run of {@link SetFilterAction}s made every handler that
 * used it a fold, which the caller had to thread state through by hand; one
 * action carrying the whole list keeps the commit a single step.
 */
export class SetColumnStagesAction {
  readonly type = "set_column_stages";
  constructor(
    readonly payload: {
      columnId: string;
      stages: FilterStage[];
    },
  ) {}
}

export class DeleteStageAction {
  readonly type = "delete_stage";
  constructor(
    readonly payload: {
      columnId: string;
      stageIndex: number;
    },
  ) {}
}

export class DeleteFilterAction {
  readonly type = "delete_filter";
  constructor(
    readonly payload: {
      columnId: string;
    },
  ) {}
}

export class ClearFiltersAction {
  readonly type = "clear_filters";
}

export class SetCombinatorAction {
  readonly type = "set_combinator";
  constructor(
    readonly payload: {
      columnId: string;
      combinator: StageCombinator;
    },
  ) {}
}
